import { Route, Routes } from "react-router-dom";
import { Row } from "antd";
import React, { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../store/store";
import { ordersIndex } from "../../store/ordersSlice/ordersSlice";
import { useSelector } from "react-redux";
import { Order } from "../../shared/interfaces/Order";
import { ordersPaginationSelectors } from "../../store/ordersSlice/ordersPaginationSlice";
import { CustomerSearch } from "./CustomerSearch";

export const Customers = () => {
  const dispatch = useAppDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const availablePages = useSelector(ordersPaginationSelectors.pages.selectIds);

  const orders = useSelector((state: RootState) =>
    ordersPaginationSelectors.get(state, currentPage)
  ) as Order[];

  useEffect(() => {
    if (availablePages && !loading && !availablePages.includes(currentPage)) {
      setLoading(true);
      dispatch(ordersIndex({ page: currentPage })).then(() => setLoading(false));
    }
  }, [currentPage, orders]);

  return (
    <Row className="page customers">
      <Routes>
        <Route path={"search"} element={<CustomerSearch />} />
      </Routes>
    </Row>
  );
};
